// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuickJournalChromaText__submissionGlint___jvifM {
    animation: QuickJournalChromaText__submissionGlint___jvifM 1000ms ease-out both;
}

@keyframes QuickJournalChromaText__submissionGlint___jvifM {
    0% {
        color: #fff8e9;
        text-shadow: -1px 0 1px rgba(167, 207, 239, .36), 1px 0 1px rgba(255, 209, 139, .42), 0 0 4px rgba(255, 226, 170, .48);
    }
    24% {
        color: #fffdf5;
        text-shadow: -1px 0 1px rgba(185, 220, 245, .42), 1px 0 1px rgba(255, 217, 157, .5), 0 0 6px rgba(255, 235, 186, .55);
    }
    100% {
        color: #ece6d9;
        text-shadow: 0 0 9px rgba(255, 228, 181, .12);
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"submissionGlint": `QuickJournalChromaText__submissionGlint___jvifM`
};
module.exports = ___CSS_LOADER_EXPORT___;
